import { useState, useRef, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Tabs,
  Tab,
  IconButton,
  Grid,
} from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import parse from "html-react-parser";
const gradlynk_API_ENDPOINT = process.env.REACT_APP_API_SAP;

const BlockCards = () => {
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);
  const [cardData, setCardData] = useState([]);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  // Scroll functions
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${gradlynk_API_ENDPOINT}get-blogs-services`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCardData(data?.data || []);
        setLoading(false);
      } else {
        console.error("Internal server error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Internal server error", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const viewDetails = (data) => {
    const url = `${data?.link || data?.alternateLink}`;
    window.open(url, "_blank"); // open in new tab
  };

  // Check scroll position to enable/disable buttons
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setIsAtStart(el.scrollLeft <= 0);
    setIsAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
  };

  // Update scroll buttons status on scroll and when data changes
  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      handleScroll(); // initial check
      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }
  }, [cardData]);
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          fontSize="22px"
          color="#333333"
          fontFamily="Inter"
          fontWeight={400}
        >
          Blogs & Articles
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          justifyContent="center"
          sx={{
            borderRadius: "20px",

            position: "relative",

            // width: "730px",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          {/* Left Nav Button */}
          <IconButton
            disabled={isAtStart}
            onClick={() => {
              scrollLeft();
            }}
            // disabled={!pagination || pagination.currentPage === 1}
            sx={{
              position: "absolute",
              top: "50%",
              left: 2,
              transform: "translateY(-50%)",
              bgcolor: "#fff",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              opacity: isAtStart ? 0.5 : 1,
              "&:hover": { bgcolor: "#f2f2f2" },
            }}
          >
            <ArrowBackIosNewIcon
              fontSize="small"
              color="#000000"
              style={{ color: "#000000" }}
            />
          </IconButton>

          {/* Right Nav Button */}
          <IconButton
            disabled={isAtEnd}
            onClick={() => {
              scrollRight();
            }}
            sx={{
              position: "absolute",
              top: "50%",
              right: 7,
              transform: "translateY(-50%)",
              bgcolor: "#fff",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              opacity: isAtEnd ? 0.5 : 1,
              "&:hover": { bgcolor: "#f2f2f2" },
            }}
          >
            <ArrowForwardIosIcon
              fontSize="small"
              color="#000000"
              style={{ color: "#000000" }}
            />
          </IconButton>

          {/* Cards Row - scrollable slider */}
          <Box
            ref={scrollRef}
            sx={{
              // px: { xs: 1, sm: 2 },
              borderRadius: "16px",
              // bgcolor: "#fafafa",
              display: "flex",
              gap: 4,
              overflowX: "auto",
              scrollBehavior: "smooth",
              "&::-webkit-scrollbar": { display: "none" },
              maxWidth: {
                xs: "300px", // mobile
                sm: "500px", // small tablets
                md: "960px", // medium screens
                lg: "1024px", // large screens
                xl: "1200px", // extra large screens
              },
              padding: "10px",
            }}
          >
            {cardData?.map((data, index) => (
              <Card
                key={data.id || index}
                sx={{
                  display: "flex",
                  flexDirection: "column", // make vertical stack
                  justifyContent: "space-between", // push content and button apart
                  borderRadius: "12px",
                  border: "1px solid #F9FAFB",
                  width: {
                    xs: "100px",
                    sm: "150px",
                    md: "300px",
                    lg: "315px",
                    xl: "360px",
                  },
                  height: "100%",

                  flexShrink: 0,
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                  backgroundColor: "white",
                  padding: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "151px",
                          borderTopLeftRadius: "12px",
                          borderTopRightRadius: "12px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={data?.image}
                          alt="IELTS Coaching"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography
                            fontSize="16px"
                            color="#333333"
                            fontFamily="Inter"
                            fontWeight={400}
                          >
                            {data?.blog_date}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} textAlign="end">
                          <Typography
                            fontSize="18px"
                            color="#9D0385"
                            fontFamily="Inter"
                            fontWeight={400}
                          >
                            {data?.sub_service}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} textAlign="start">
                      <Typography
                        fontSize="16px"
                        color="#000000"
                        fontFamily="Inter"
                        fontWeight={500}
                      >
                        {data?.blog_name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} textAlign="start">
                      <Typography
                        fontSize="12px"
                        color="#222222"
                        fontFamily="Inter"
                        fontWeight={400}
                        sx={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3, // 👈 limit to 3 lines
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {parse(String(data?.blog_short_content))}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* 👇 Button pinned at the bottom */}
                <Box mt="auto" textAlign="center" pt={2}>
                  <Button
                    variant="contained"
                    onClick={() => viewDetails(data)}
                    style={{
                      background: "#9D0385",
                      fontWeight: "500",
                      borderRadius: "24px",
                      fontSize: "14px",
                      paddingLeft: 20,
                      paddingRight: 20,
                      fontFamily: "Inter",
                      height: "28px",
                      width: "100%",
                      "&:hover": {
                        textDecoration: "none",
                      },
                    }}
                  >
                    Explore More
                  </Button>
                </Box>
              </Card>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BlockCards;
